if (!customElements.get("card-slider")) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute("data-swiper-options")) || {};

      window.addEventListener("shopify:section:load", () => {
        this.initSlider(swiperOptions);
      });

      this.initSlider(swiperOptions);

      if (this.classList.contains("js-testimonials")) {
        const initOrUpdateSlider = () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect = this.slider && this.slider.params.effect === "slide";

          if ((isMobile && !isSlideEffect) || (!isMobile && isSlideEffect)) {
            this.reInitSlider(swiperOptions);
          }
        };

        initOrUpdateSlider();

        window.addEventListener("resize", initOrUpdateSlider);
      }

      // if window is resized, re-init slider
      window.addEventListener("resize", () => {
        if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
          if (this.slider) {
            this.slider.destroy();
          }
        } else if (!this.slider) {
          this.initSlider(swiperOptions);
        }
      });
    }

    reInitSlider(swiperOptions) {
      this.slider.destroy();
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      // swiperOptions.disabledOnMobile = true;
      if (
        swiperOptions.disabledOnMobile &&
        window.innerWidth < mobileWidth
      ) {
        return;
      }

      // Swiper Pagination Option
      if (swiperOptions.pagination == "render_bullet") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (i, className) {
            return `
              <button class="${className}">
                <span>${i + 1}</span>
              </button>
            `;
          }
        };
      } else if (swiperOptions.pagination == "progressbar") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          type: "progressbar"
        };
      } else if (swiperOptions.pagination == "bullets") {
        swiperOptions.pagination = {
          el: ".swiper-pagination",
          clickable: true
        };
      } else {
        swiperOptions.pagination = false;
      }


      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1.1,
        spaceBetween: swiperOptions.spaceBetweenMobile ?? 16,
        centeredSlides: swiperOptions.centeredSlides || false,
        resistanceRatio: 0.72,
        navigation: swiperOptions.navigation || { nextEl: ".swiper-button--next", prevEl: ".swiper-button--prev" },
        breakpoints: {
          480: {
            slidesPerView: "auto",
            spaceBetween: swiperOptions.spaceBetweenMobile || 2
          },
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop ?? 16
          }
        }
      };

      const isArticlesSlider = this.classList.contains("js-articles");
      const isCollectionSlider =
        this.classList.contains("js-collections");
      const isFeaturedProductsSlider = this.classList.contains(
        "js-featured-products"
      );

      if (isArticlesSlider || isCollectionSlider || isFeaturedProductsSlider) {
        sliderOptions.breakpoints[575] = {
          slidesPerView: 2
        };
      } else if (this.classList.contains("horizontal-w-media")) {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          centeredSlides: swiperOptions.centeredSlides || false,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          pagination: swiperOptions.pagination || false,
          navigation: swiperOptions.navigation || {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          },
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 1,
              loop: swiperOptions.loop || false
            }
          }
        };
      } else if (this.classList.contains("vertical-w-media")) {

        if (window.innerWidth > 750) {

        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          centeredSlides:true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (i, className) {
              return `<button class="${className}"><span>${
                i + 1
              }</span></button>`;
            }
          },
          navigation: swiperOptions.navigation || {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          },
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 2.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (i, className) {
                  return `<button class="${className}"><span>${
                    i + 1
                  }</span></button>`;
                }
              }
            },
            990: {
              slidesPerView: 1,
              grid: {
                rows: 3
              }
            }
          }
        };

      } else {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          centeredSlides: true,
          navigation: swiperOptions.navigation || {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          },
          loop: swiperOptions.loop || false,
          autoplay: swiperOptions.autoplay || false
        };
      }


      } else if (this.classList.contains("carousel-none-media")) {
        sliderOptions = {
          slidesPerView: swiperOptions.slidesPerView || 1.1,
          followFinger: swiperOptions.followFinger || false,
          spaceBetween: swiperOptions.spaceBetweenMobile || 16,
          pagination: swiperOptions.pagination || false,
          navigation: swiperOptions.navigation || {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          },
          loop: swiperOptions.loop || false,
          loopedSlides: 9,
          additionalSlides: 9,
          autoplay: swiperOptions.autoplay || false,
          breakpoints: {
            750: {
              slidesPerView: 3.2,
              spaceBetween: swiperOptions.spaceBetweenDesktop || 16
            },
            990: {
              slidesPerView: 4.2
            }
          }
        };
      } else {
        sliderOptions = {
          effect: "fade",
          slidesPerView: 1,
          followFinger: false,
          navigation: {
            nextEl: ".swiper-button--next",
            prevEl: ".swiper-button--prev"
          }
        };
      }

      this.slider = new Swiper(this, {...sliderOptions, centeredSlides: swiperOptions.centeredSlides || false});

      if (this.classList.contains('js-testimonials')) {
        const defaultDurationStr = getComputedStyle(this).getPropertyValue('--autoplay-duration') || '3s';
        const defaultDuration = parseFloat(defaultDurationStr) * 1000; // Convert to ms
        let slideTimeout = null;
        let currentVideoEndHandler = null;

        // Disable Swiper autoplay - we handle timing manually
        if (this.slider.autoplay) {
          this.slider.autoplay.stop();
        }

        // Testimonial videos come with their file deferred (snippets/lazy-video.liquid,
        // observe: false): only the slide that is about to play downloads its video.
        const loadVideo = video => {
          const sources = video.querySelectorAll('source[data-src]');
          if (!sources.length) return;
          sources.forEach(source => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.preload = 'auto';
          video.load();
        };

        const clearSlideTimer = () => {
          if (slideTimeout) {
            clearTimeout(slideTimeout);
            slideTimeout = null;
          }
          if (currentVideoEndHandler) {
            currentVideoEndHandler.video.removeEventListener('ended', currentVideoEndHandler.handler);
            currentVideoEndHandler = null;
          }
        };

        // Swiper fires slideChangeTransitionEnd while setting up the loop, even far below the
        // first screen: only play (and download) the active video while the section is in view.
        let inView = false;

        const handleSlide = () => {
          // Clear any existing timers
          clearSlideTimer();
          if (!inView) return;

          // Get active slide (handle both regular and duplicate active slides in loop mode)
          const activeSlide = this.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)')
            || this.querySelector('.swiper-slide-active');
          const activeMedia = activeSlide ? activeSlide.querySelector('.testimonial__media') : null;
          const activeVideo = activeMedia ? activeMedia.querySelector('.testimonial__video') : null;

          // Pause and reset ALL videos first
          this.querySelectorAll('.testimonial__video').forEach(video => {
            video.pause();
            video.currentTime = 0;
          });
          this.querySelectorAll('.testimonial__media').forEach(media => {
            media.classList.remove('video-playing');
          });

          // Handle active slide
          if (activeSlide) {
            if (activeVideo) {
              // Video slide - wait for video to end
              activeMedia.classList.add('video-playing');

              loadVideo(activeVideo);

              // Small delay to ensure pause has completed before playing
              setTimeout(() => {
                activeVideo.currentTime = 0;
                activeVideo.play().catch(error => {
                  if (error.name !== 'AbortError') {
                    console.error("Video play failed:", error);
                  }
                });
              }, 50);

              // Update CSS duration for progress bar
              const updateDuration = () => {
                if (activeVideo.duration && !isNaN(activeVideo.duration)) {
                  activeSlide.style.setProperty('--autoplay-duration', activeVideo.duration + 's');
                }
              };
              if (activeVideo.readyState >= 1) {
                updateDuration();
              } else {
                activeVideo.addEventListener('loadedmetadata', updateDuration, { once: true });
              }

              // Advance when video ends
              const onVideoEnd = () => {
                this.slider.slideNext();
              };
              activeVideo.addEventListener('ended', onVideoEnd, { once: true });
              currentVideoEndHandler = { video: activeVideo, handler: onVideoEnd };

            } else {
              // Photo slide - use timeout
              activeSlide.style.setProperty('--autoplay-duration', defaultDurationStr);
              slideTimeout = setTimeout(() => {
                this.slider.slideNext();
              }, defaultDuration);
            }
          }
        };

        this.slider.on('slideChange', clearSlideTimer);
        this.slider.on('slideChangeTransitionEnd', handleSlide);

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const wasInView = inView;
            inView = entry.isIntersecting;
            if (inView && !wasInView) {
              handleSlide();
            } else if (!inView && wasInView) {
              clearSlideTimer();
              this.querySelectorAll('.testimonial__video').forEach(video => video.pause());
            }
          });
        }, { threshold: 0.5 });

        observer.observe(this);

        // Track if user is swiping to prevent click interference
        let isSwiping = false;
        this.slider.on('touchMove', () => { isSwiping = true; });
        this.slider.on('touchEnd', () => { setTimeout(() => { isSwiping = false; }, 50); });

        this.slider.slides.forEach((slide) => {
          slide.addEventListener('click', () => {
            // Ignore clicks that are part of swipe gestures
            if (isSwiping) return;

            if (!slide.classList.contains('swiper-slide-active')) {
              // Immediately stop all videos and clear timers
              clearSlideTimer();
              this.querySelectorAll('.testimonial__video').forEach(video => {
                video.pause();
                video.currentTime = 0;
              });
              this.querySelectorAll('.testimonial__media').forEach(media => {
                media.classList.remove('video-playing');
              });

              const clickedIndex = slide.getAttribute('data-swiper-slide-index');
              if (clickedIndex !== null) {
                this.slider.slideToLoop(parseInt(clickedIndex));
                // Trigger handleSlide after transition
                setTimeout(() => handleSlide(), 350);
              }
            }
          });
        });
      }
    }
  }

  customElements.define("card-slider", CardSlider);
}
